export enum TabScreens {
  Home = 'Home',
  Menu = 'Menu',
  Notification = 'Notification',
  User = 'User',
  Order = 'Order',
}

export enum Routes {
  PointScreen = '/points',
  Onboarding = '/',
  SignIn = '/sign-in',
  OrderHistory = '/profile/orders',
  PaymentMethods = '/profile/payment-method',
  OrderHistoryEmpty = '/profile/orders-empty',
  EditProfile = '/profile/edit',
  VerifyYourEmail = '/verify-your-email',
  MyPromocodes = '/profile/promocodes',
  NewPassword = '/new-password',
  Filter = '/filter',
  SignUp = '/sign-up',
  SignUpAccountCreated = '/sign-up-account-created',
  ForgotPassword = '/forgot-password',
  OrderSuccessful = '/order-successful',
  Checkout = '/checkout',
  ForgotPasswordSentEmail = '/forgot-password-sent-email',
  Shop = '/shop',
  PromocodesEmpty = '/promocodes-empty',
  Reviews = '/reviews',
  Description = '/description',
  LeaveAReviews = '/leave-a-reviews',
  Product = '/product/:id',
  MyPromocodesEmpty = '/profile/promocodes-empty',
  TabNavigator = '/tab-navigator',
  Verification = '/verification',
  ConfirmationCode = '/confirmation-code',
  SendEmailOtp = '/send-email-otp',
  VerifyEmail = '/verify-email',
  SendPhoneOtp = '/send-phone-otp',
  VerifyPhone = '/verify-phone',
  EmailVerified = '/email-verified',
  PhoneVerified = '/phone-verified',
  MenuList = '/menu-list',
  Search = '/search',
  Wallet = '/wallet',
  Promocodes = '/promocodes',
  ShippingAPaymentInfo = '/shipping-a-payment-info',
  OrderFailed = '/order-failed',
  TrackYourOrder = '/track-your-order',
  LeaveAReview = '/leave-a-review',
  FAQ = '/faq',
  Dish = '/dish/:id',
  ItemDetail = "/itemDetail",
  MealDetail = "/mealDetail",
  CustomizeItemForItemOnly = '/customizeItemForItemOnly',
  CustomizeItemForMealOnly = '/customizeItemForMealOnly',
  MyAddress = '/my-address',
  CheckoutPaymentMethod = '/checkout-payment-method',
  CheckoutShippingDetails = '/checkout-shipping-details',
  AddANewAddress = '/add-a-new-address',
  AddANewCard = '/add-a-new-card',
  VerifyYourPhoneNumber = '/verify-your-phone-number',
  OrderSummary = '/orderSummary',
}
